import React from 'react';
import PropTypes from 'prop-types';
import { AccordionContent, AccordionWrapper, ArrowImg, Description, Heading } from './DescriptionAccordion.css';
import { genRandomStr } from '../../../components_mobile/helpers/helpers';
import { track } from '../../../helpers/tracking';
import TrackingEvents from '../../../common/models/TrackingEvents';

class DescriptionAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: !props.collapsed };
  }

  generateParagraphs(arrayOfText) {
    return arrayOfText.map(text => {
      const paragraph = text.includes('</a>') ? <p dangerouslySetInnerHTML={{ __html: text }} /> : <p>{text}</p>;

      return (
        <div key={genRandomStr()}>
          {paragraph}
          <br />
        </div>
      );
    });
  }

  generateDescription(isDesktop, dataCy, text) {
    const hasHtml = /<[a-zA-Z][\s\S]*>/.test(text);
    return (
      <div>
        {hasHtml && <Description data-cy={dataCy} isDesktop={isDesktop} dangerouslySetInnerHTML={{ __html: text }} />}
        {!hasHtml && (
          <Description data-cy={dataCy} isDesktop={isDesktop}>
            {text}
          </Description>
        )}
      </div>
    );
  }

  detailsExpandedIcon() {
    const { isDesktop, s3BasePath } = this.props;
    return isDesktop ? `${s3BasePath}mkt/icon/arrow_down_black.png` : `${s3BasePath}mkt/icon/arrow_down_grey.png`;
  }

  detailsCollapsedIcon() {
    const { isDesktop, s3BasePath } = this.props;
    return isDesktop ? `${s3BasePath}mkt/icon/arrow_right_black.png` : `${s3BasePath}mkt/icon/arrow_right_grey.png`;
  }

  renderDesktopContent(body) {
    const { dataCy, extra, isDesktop } = this.props;
    const { visible } = this.state;
    return (
      <AccordionContent visible={visible}>{this.generateDescription(isDesktop, dataCy, body, extra)}</AccordionContent>
    );
  }

  renderMobileContent(body) {
    const { dataCy, extra, isDesktop } = this.props;
    const { visible } = this.state;
    return visible ? this.generateDescription(isDesktop, dataCy, body, extra) : null;
  }

  render() {
    const { dataCy, margin, text, title, isDesktop } = this.props;
    const { visible } = this.state;
    const arrowImgUrl = visible ? this.detailsExpandedIcon() : this.detailsCollapsedIcon();
    const body = Array.isArray(text) ? this.generateParagraphs(text) : `<p>${text}</p><br>`;

    return body ? (
      <AccordionWrapper margin={margin}>
        <Heading
          data-cy="accordion-description-heading"
          isDesktop={isDesktop}
          dim={visible}
          onClick={() => {
            track(visible ? TrackingEvents.infoCollapsed() : TrackingEvents.infoExpanded(), { ui: { type: title } });
            this.setState({ visible: !visible });
          }}
        >
          <ArrowImg isDesktop={isDesktop} src={arrowImgUrl} />
          {title || 'Description'}
        </Heading>
        {isDesktop ? this.renderDesktopContent(body) : this.renderMobileContent(body)}
      </AccordionWrapper>
    ) : null;
  }
}

DescriptionAccordion.propTypes = {
  collapsed: PropTypes.bool,
  dataCy: PropTypes.string,
  isDesktop: PropTypes.bool,
  margin: PropTypes.string,
  s3BasePath: PropTypes.string.isRequired,
  text: PropTypes.any,
  title: PropTypes.string,
};

export default DescriptionAccordion;
